/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S5_Phone_BeforeInputs */

const tr_hakkimizda_s5_phone_before = /** @type {(inputs: Hakkimizda_S5_Phone_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri Hizmetleri hattımız`)
};

const en_hakkimizda_s5_phone_before = /** @type {(inputs: Hakkimizda_S5_Phone_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Customer Service line is`)
};

const de_hakkimizda_s5_phone_before = /** @type {(inputs: Hakkimizda_S5_Phone_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Kundenservice-Hotline`)
};

const ru_hakkimizda_s5_phone_before = /** @type {(inputs: Hakkimizda_S5_Phone_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша линия обслуживания клиентов`)
};

/**
* | output |
* | --- |
* | "Our Customer Service line is" |
*
* @param {Hakkimizda_S5_Phone_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s5_phone_before = /** @type {((inputs?: Hakkimizda_S5_Phone_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S5_Phone_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s5_phone_before(inputs)
	if (locale === "de") return de_hakkimizda_s5_phone_before(inputs)
	if (locale === "ru") return ru_hakkimizda_s5_phone_before(inputs)
	return tr_hakkimizda_s5_phone_before(inputs)
});